
define('text!templates/modules/calendar/calendar/summary/summary.html',[],function () { return '<div class="urow summary open">\n    <div class="tc-row">\n        <div class="activity-table"></div>\n        <div class="average-table"></div>\n        <div class="total-table"></div>\n    </div>\n</div>\n';});

